export default {
  LIST_FETCHED: 'GIVEAWAY_NUMBERS_FETCHED',
  LIST_LOAD: 'GIVEAWAY_NUMBERS_LOAD',
  TEMPLATES_FETCHED: 'GIVEAWAY_NUMBERS_TEMPLATES_FETCHED',
  TEMPLATES_LOAD: 'GIVEAWAY_NUMBERS_TEMPLATES_LOAD',
  ITEM_DETAIL: 'GIVEAWAY_NUMBERS_DETAIL',
  BUTTON_LOAD: 'GIVEAWAY_NUMBERS_BUTTON_LOAD',
};
